import { render, staticRenderFns } from "./MovieAccentExpertBreaksDown.vue?vue&type=template&id=133161d5&scoped=true&"
import script from "./MovieAccentExpertBreaksDown.vue?vue&type=script&lang=js&"
export * from "./MovieAccentExpertBreaksDown.vue?vue&type=script&lang=js&"
import style0 from "./MovieAccentExpertBreaksDown.vue?vue&type=style&index=0&id=133161d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133161d5",
  null
  
)

export default component.exports